<i18n locale="en">
{
  "alt": {
    "appStore": "Download on the App Store",
    "googlePlay": "Get it on Google Play"
  },
  "no-apps": "No apps are live. Remove this section to send."
}
</i18n>

<template>
  <PreviewSheet
    radius="0"
    background="primary"
    class="get-the-app-buttons-preview"
  >
    <div
      v-if="hasNoApps"
      class="get-the-app-buttons-preview__warning"
      role="alert"
    >
      <OwnType variant="paragraph-small" color="danger" :text="t('no-apps')" />
    </div>
    <div v-else class="get-the-app-buttons-preview__row">
      <div v-if="hasAppStore" class="get-the-app-buttons-preview__link">
        <img
          :alt="t('alt.appStore')"
          class="get-the-app-buttons-preview__img"
          :src="IOS_STORE_ICON"
        />
      </div>
      <div v-if="hasPlayStore" class="get-the-app-buttons-preview__link">
        <img
          :alt="t('alt.googlePlay')"
          class="get-the-app-buttons-preview__img"
          :src="ANDROID_STORE_ICON"
        />
      </div>
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import globalStore from '@/store'
import { OwnType } from '@/ui/OwnType'

import {
  getBrandAppPlatforms,
  getBrandHasApp,
} from '../../../composables/useBrandHasApp'

const { t } = useI18n()

const storeModule = inject<string>('storeModule')
const currentResource = computed(
  () => storeModule && globalStore.getters[`${storeModule}/currentResource`]
)
const platforms = computed(() =>
  getBrandAppPlatforms(currentResource.value?.brandId)
)
const hasAppStore = computed(() => platforms.value?.hasAppStore ?? false)
const hasPlayStore = computed(() => platforms.value?.hasPlayStore ?? false)
const hasNoApps = computed(
  () => getBrandHasApp(currentResource.value?.brandId) === false
)

// Official badges: use apple.svg and google.svg in public/static/app-stores/ (see README there)
const IOS_STORE_ICON = '/static/app-stores/apple.svg'
const ANDROID_STORE_ICON = '/static/app-stores/google.svg'
</script>

<style lang="scss" scoped>
.get-the-app-buttons-preview {
  padding: 12px 16px;

  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  &__warning {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    background-color: var(--background-danger);
    border-radius: 8px;
  }

  &__link {
    display: block;
    line-height: 0;
  }

  &__img {
    display: block;
    height: 48px;
    width: auto;
    border: 0;
  }
}
</style>
